import {useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../../redux/store.type';
import {sendWhatsAppTemplateTrial} from '../../../../../redux/branding/brandingActions';
import useGlobalShow from '../../../../../hooks/useGlobalShow';
import useRestartXHR from '../../../../../hooks/useRestartXHR';
import {UseTrialHandlersProps} from '../types';
import {convertToWhatsappText} from '../../../../whatsAppTemplateEditor/utils/formatUtils';

export const useTrialHandlers = ({messageText, imagePath, messageType, currentLang, trialPopupShow, show}: UseTrialHandlersProps) => {
    const sendWhatsAppTemplateTrialXHR = useSelector((state: RootState) => state.branding.sendWhatsAppTemplateTrialXHR);
    const [localTrialContacts, setLocalTrialContacts] = useState<string[]>([]);
    const sendApprovalShow = useGlobalShow('isOpenSendApproval');
    const successShow = useGlobalShow('isOpenSuccess');

    useRestartXHR(sendWhatsAppTemplateTrialXHR, 'branding.sendWhatsAppTemplateTrialXHR');

    const handleTrialSend = (contacts: string[]) => {
        setLocalTrialContacts(contacts);
        sendApprovalShow.open();
        trialPopupShow.close();
    };

    const handleActualTrialSend = async () => {
        try {
            const trialData = {
                message: convertToWhatsappText(messageText),
                image: imagePath,
                trialPhones: localTrialContacts,
                messageType: messageType,
                lang: currentLang
            };
            await sendWhatsAppTemplateTrial(trialData).then((result) => {
                if(result.message) {
                    successShow.open();
                    sendApprovalShow.close();
                }
            });
        } catch (error) {
            console.error('Failed to send WhatsApp trial:', error);
        }
    };

    const handleClose = () => {
        setLocalTrialContacts([]);
        trialPopupShow.close();
        sendApprovalShow.close();
        successShow.close();
        show.close();
    };

    return {
        localTrialContacts,
        sendApprovalShow,
        successShow,
        sendWhatsAppTemplateTrialXHR,
        handleTrialSend,
        handleActualTrialSend,
        handleClose
    };
};
